import { Spin } from "antd";

export const Loader = (_props) => (
  <div style={{ width: "100%", textAlign: "center" }}>
    <Spin tip="Loading..."></Spin>
  </div>
);
